<template>
  <b-nav
    ref="routes"
    :class="$style.routesList"
    :style="navarWrapperLegacy"
    class="py-1"
  >
    <b-nav-item
      active
      :to="{
        name: 'PublicSiteHome',
        params: { site: slug },
      }"
    >Home</b-nav-item>
    <!-- <b-nav-item :to="{ name: 'how-it-works' }">How it Works</b-nav-item> -->
    <!-- <b-nav-item>Build Your Subscription Box</b-nav-item> -->
    <!-- <b-nav-item
      v-if="showMingleAndNoshLink()"
      :class="$style.link"
      :to="{ name: 'mingle-and-nosh' }"
    >
      Mingle + Nosh
    </b-nav-item> -->

    <b-nav-item
      v-if="showParentsLink()"
      :class="$style.link"
      :to="{ name: 'parents' }"
    >
      For Parents
    </b-nav-item>

    <b-nav-item
      v-if="showCateringLink()"
      :class="$style.link"
      :to="{ name: 'catering' }"
    >
      Order Catering
    </b-nav-item>

    <b-nav-item
      :class="$style.link"
      :to="{ name: 'locations' }"
    >
      Locations
    </b-nav-item>

    <b-nav-item
      :class="$style.link"
      :to="{ name: 'categories' }"
    >
      Browse Categories
    </b-nav-item>

    <!-- Search link in nav -->
    <b-nav-item
      ref="searchLink"
      :class="$style.searchLink"
    >
      Search
    </b-nav-item>

    <b-nav-form
      ref="searchBar"
      :class="$style.searchBoxWrapper"
      @submit="triggerSearch"
    >
      <b-form-input
        v-model="searchValue"
        :class="$style.searchBox"
        size="sm"
        class="mr-sm-2"
        placeholder="Search"
      />
      <b-button
        squared
        size="sm"
        :class="$style.searchButton"
        type="submit"
      >
        Go
      </b-button>
    </b-nav-form>
  </b-nav>
</template>

<script>
import { mapGetters } from 'vuex'

import { authComputed } from '@state/helpers'

export default {
  components: {},

  props: {
    site: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      searchValue: '',
    }
  },

  computed: {
    ...authComputed,
    ...mapGetters({
      slug: 'sites/getSiteSlug',
    }),
  },

  methods: {
    navarWrapperLegacy() {
      if (this.checkIE === true) {
        return {
          justifyContent: 'flex-start',
        }
      } else {
        return {
          justifyContent: 'end',
        }
      }
    },

    showCateringLink() {
      if (this.site.shopCateringSection && this.site.hasCateringItems) {
        return true
      }
      return false
    },

    showMingleAndNoshLink() {
      if (this.site.mingleNoshActive && this.site.hasMingleNoshItems) {
        return true
      }
      return false
    },

    showParentsLink() {
      if (this.site.shopParentSection && this.site.hasParentItems) {
        return true
      }
      return false
    },

    triggerSearch(evt) {
      evt.preventDefault()
      this.$router.push({
        name: 'search-results',
        params: { site: this.slug, slug: this.searchValue },
      })
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.link {
  cursor: pointer;
}
.routesList {
  a {
    padding: 20px;
    color: var(--brandColor);
  }
}
.searchBoxWrapper {
  margin-left: auto;
}

.searchLink {
  cursor: pointer;
  opacity: 0;
}

.searchBox {
  width: 300px !important;
  height: 3rem;
  padding: 12px 10px !important;
  color: #444;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0;
  &:focus {
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
  }
}

.searchButton {
  position: relative;
  top: -1px;
  padding: 12px;
  color: var(--brandColor);
  background-color: #fff;
  border: 1px solid var(--brandColor);
}

.searchButton:hover,
.searchButton:focus {
  color: #fff;
  background-color: var(--brandColor);
  border-color: var(--brandColor);
}
</style>
